var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-tooltip',{attrs:{"disabled":_vm.tooltipDisabled,"text":_vm.getTooltip}},[_c('BaseBtn',_vm._g(_vm._b({staticClass:"ma-0 pa-0 px-2",attrs:{"color":_vm.getBTNColor?_vm.getBTNColor:'primary',"pHeight":"30"}},'BaseBtn',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n    "+_vm._s(_vm.getTooltip)+"\n    "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }